import {
  SliderOwnProps,
  Stack,
  StackOwnProps,
  Typography,
} from '@mui/material';
import { PlayerStatus } from 'features/cameras/cameras.types';
import { formatDate, getTimeAgo } from 'shared/dates';
import { TouchEventHandler } from 'react';
import { WatchDutySlider } from 'components/WatchDutySlider';

type TimelapseSliderProps = {
  imageTimestamp: Date;
  isLoading: boolean;
  playerStatus: PlayerStatus;
  timelapseFrameNumber: number;
  timelapseFramesLength: number;
  handleSliderChange: SliderOwnProps<number>['onChange'];
  spacing?: StackOwnProps['spacing'];
  dark?: boolean;
  onTouchStart?: TouchEventHandler<HTMLSpanElement>;
  onTouchEnd?: TouchEventHandler<HTMLSpanElement>;
};

export const TimelapseSlider = (props: TimelapseSliderProps): JSX.Element => {
  const {
    imageTimestamp,
    isLoading,
    playerStatus,
    timelapseFrameNumber,
    timelapseFramesLength,
    handleSliderChange,
    spacing,
    dark = false,
    onTouchStart,
    onTouchEnd,
  } = props;

  const currentFrameTimeString = formatDate(imageTimestamp, 'MMM d hh:mm a');
  const currentFrameTimeRelativeString = ` • ${getTimeAgo(
    imageTimestamp.toISOString(),
  )}`;

  return (
    <Stack
      spacing={spacing}
      sx={{
        width: '100%',
        pointerEvents: 'auto',
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 'bold',
          marginY: 0.5,
          color: 'text.primary',
          marginBottom: '16px',
        }}
      >
        {currentFrameTimeString}
        {currentFrameTimeRelativeString}
      </Typography>
      <WatchDutySlider
        color="accent"
        size="small"
        value={timelapseFrameNumber}
        onChange={handleSliderChange}
        min={0}
        max={Math.max(timelapseFramesLength - 1, 1)} // max at least 1 so that a value of zero displays correctly
        disabled={isLoading || playerStatus === 'streamingLive'}
        sx={
          dark
            ? {
                '.MuiSlider-rail': {
                  color: 'grey.100',
                  opacity: 0.76, // 2x default opacity
                },
              }
            : undefined
        }
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      />
    </Stack>
  );
};
